import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class StepperService {
    constructor() {
        this.stepperSubject = new BehaviorSubject([]);
        this.stepperObservable = this.stepperSubject.asObservable();
    }
    setStepper(step) {
        this.stepperSubject.next(step);
    }
    getSteper() {
        return this.stepperObservable;
    }
}
StepperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StepperService_Factory() { return new StepperService(); }, token: StepperService, providedIn: "root" });
